export default {
  methods: {
    getColorSizes(product) {
      const productColorSelected = product?.product_colors.find(color => {
          return product.product_option_value_id_color === color.product_option_value_id;
      });
      if(productColorSelected) {
          return product.product_sizes
            .filter(size => Object.keys(productColorSelected.available_sizes).includes(size.product_option_value_id))
            .map(size => ({
              ...size,
              ...productColorSelected.available_sizes[size.product_option_value_id]
            }));
      } else {
          return product?.product_sizes || [];
      }
    },
    updateValidation(option, product) {
      this.$set(product, 'warnAbout', {
          ...product.warnAbout,
          [option]: product[`product_option_value_id_${option}`] ? false : true
      });
    },
    updatePristineStatus(option, product) {
      this.$set(product, 'isPristine', {
        ...product.isPristine,
        [option]: false,
      });
    },
    setOption(option, product, event) {
        this.$set(product, `product_option_value_id_${option}`, event.target.value);
        this.updateValidation(option, product);
        this.updatePristineStatus(option, product);
        return product;
    },
    checkOptionSelected(product, option, hasOptions) {
      return product[`product_option_value_id_${option}`] || !hasOptions
    },
  },
  computed: {
    
  }

}